
export const getSentTimeLocal = (timestamp)=>{
    const date = new Date(timestamp + new Date().getTimezoneOffset())
    const minutes = (date.getMinutes().toString().length === 1)?('0'+date.getMinutes()):date.getMinutes()
    return date.getDate()+'/'+(date.getMonth()+1)+'/'+date.getFullYear()+' '+date.getHours()+':'+minutes
}
